import { render } from "./conference.vue?vue&type=template&id=5f5794fe"
import script from "./conference.vue?vue&type=script&lang=js"
export * from "./conference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__